import React from 'react'
import TablePage from "../../../common/TablePage";
import { bindActionCreators } from "redux";
import * as Actions from "../../../actions/Actions";
import { withRouter } from "react-router-dom";
import connect from "react-redux/es/connect/connect";
import strings from "../../../localization";
import { withSnackbar } from "notistack";
import { getDeceasedReceptions, deleteDeceasedReception } from '../../../services/deceasedReception/DeceasedReceptionService';
import AddUrnTakeoverRecord from './AddUrnTakeoverRecord';
import EditUrnTakeoverRecord from './EditUrnTakeoverRecord';
import ViewUrnTakeoverRecord from './ViewUrnTakeoverRecord';


class UrnTakeoverRecordList extends TablePage {

  tableDescription = [
    { key: 'deceasedNameSurname', label: strings.urnTakeoverRecordList.deceasedNameSurname, sort: 'deceasedNameSurname' },
    { key: 'dateCreated', label: strings.urnTakeoverRecordList.dateCreated, transform: 'renderColumnDate', sort: 'dateCreated' },
  ];


  constructor(props) {
    super(props);

    this.state.sortBy = "deceasedNameSurname,ASC";

  }

  fetchData() {
    let data = {
      searchParam: this.state.searchData.search,
      page: this.state.searchData.page - 1,
      size: this.state.searchData.perPage,
      companyId: this.state.companyId,
      sort: this.state.sortBy,
      type: 2,
      userId: this.props.auth.user.id
    };

    {
      this.state.companyId != undefined &&
        getDeceasedReceptions(data).then(response => {
          if (!response.ok) {
            return;
          }
          this.setState({
            tableData: response.data.entities,
            total: response.data.total,
          });
        });
    }
  }

  usePermissions(){
    let data = {
      userId: this.props.auth.user.id,
      category: "Записник о преузимању урне"
    }
    this.getPermissionsS(data);
    this.showAdd(this.props.showAdd);
    this.showRemove(this.props.remove);
    this.showEdit(this.props.showEdit);
    this.showView(this.props.showView);
    this.removedItemsShow(this.props.removedItemsShow);

  }
  componentDidMount() {
    this.usePermissions()
    this.setState({
      companyId: this.props.auth.user.company.id
    }, () => { this.fetchData(); })
  }

  componentWillReceiveProps(nextProps) {
    strings.setLanguage(nextProps.auth.user.language);
    this.tableDescription = [
      { key: 'deceasedNameSurname', label: strings.urnTakeoverRecordList.deceasedNameSurname, sort: 'deceasedNameSurname' },
      { key: 'dateCreated', label: strings.urnTakeoverRecordList.dateCreated, transform: 'renderColumnDate', sort: 'dateCreated' },
    ];
  }

  getPageHeader() {
    return <h1>{strings.urnTakeoverRecordList.pageTitle}</h1>;
  }

  renderAddContent() {
    return <AddUrnTakeoverRecord
      cid={this.state.companyId}
      uemail={this.props.auth.user.email}
      onCancel={this.onCancel}
      onFinish={this.onFinish}
      flag={"add"}
    />
  }

  renderEditContent() {
    return <EditUrnTakeoverRecord
      id={this.state.selectedItem.id}
      uemail={this.props.auth.user.email}
      cid={this.state.companyId}
      onCancel={this.onCancel}
      onFinish={this.onFinish}
      isDisabled={false}
      flag={"edit"}
      auth={this.props.auth}
    />
  }

  renderViewContent() {

    return <ViewUrnTakeoverRecord
      id={this.state.selectedItem.id}
      isDisabled={true}
      onCancel={this.onCancel}
      onFinish={this.onFinish}
      flag={"view"}
      auth={this.props.auth}
    />
  }

  delete(item) {

    this.setState({
      lockTable: true
    });


    deleteDeceasedReception(item.id, this.props.auth.user.id).then(response => {

      if (response && !response.ok) {
        this.onFinish(null);
        return;
      }

      this.props.enqueueSnackbar(strings.companyList.urnTakeoverRecordDeleted, { variant: 'success' });

      this.onFinish(item);
      this.cancelDelete();

      this.setState({
        lockTable: false
      });
    });
  }

}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    changeFullScreen: Actions.changeFullScreen
  }, dispatch);
}

function mapStateToProps({ menuReducers, authReducers, siteDataReducers }) {
  return { menu: menuReducers, auth: authReducers, siteData: siteDataReducers };
}

export default withSnackbar(withRouter(connect(mapStateToProps, mapDispatchToProps)(UrnTakeoverRecordList)));